import { useState, useEffect } from "react";
import Subcription from "./Subcription";
import Princing from "./Princing";

const PricingIndex = () => {
  const [value, setValue] = useState("pricing");

  // Read URL parameters on component mount and when URL changes
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const tabParam = urlParams.get("tab");

    // If tab is subscription, show subscription page
    if (tabParam === "subscription") {
      // Default to pricing
      setValue("pricing");
    } else {
      setValue("subscription-page");
    }
  }, []);

  // HereListen for URL changes (browser back/forward)
  useEffect(() => {
    const handlePopState = () => {
      const urlParams = new URLSearchParams(window.location.search);
      const tabParam = urlParams.get("tab");

      // If tab is subscription, show subscription page
      if (tabParam === "subscription") {
      // Default to pricing
        setValue("pricing");
      } else {
        setValue("subscription-page");
      }
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  const selectUpgrade = () => {
    setValue("subscription-page");
    // Update URL when navigating to subscription
    const url = new URL(window.location);
    const params = new URLSearchParams(url.search);
    params.set("tab", "subscription");
    params.set("view", "pricing");
    window.history.pushState({}, "", `${url.pathname}?${params.toString()}`);
  };

  const goBack = () => {
    setValue("pricing");
    // Update URL when going back to pricing
    const url = new URL(window.location);
    const params = new URLSearchParams(url.search);
    params.delete("tab");
    params.delete("view");

    // If there are still other params, keep them
    const newUrl = params.toString() ? `${url.pathname}?${params.toString()}` : url.pathname;
    window.history.pushState({}, "", newUrl);
  };

  return (
    <>
      {value === "pricing" && (
        <Princing next={selectUpgrade} />
      )}
      {value === "subscription-page" && (
        <Subcription back={goBack} />
      )}
    </>
  );
};

export default PricingIndex;
